import { Navigate } from "react-router-dom"
import { useAppSelector } from "app/hooks"
import PATHS from "./paths"
import type { RouteObject } from "react-router-dom"
import AppLayout from "components/Layouts/AppLayout"
import SetGoal from "features/onboarding/SetGoal"
import Home from "features/home/Diary"
import PersonalInfo from "features/onboarding/PersonalInfo"
import ScanMeal from "features/meal/ScanMeal/index"
import Overview from "features/overview/Overview"
import Tutorial from "features/meal/Tutorial"
import CreateFood from "features/food/CreateMyFood"
import FoodDetails from "features/food/MyFoodDetails"
import UpdateFood from "features/food/UpdateMyFood"
import UpdateMeals from "features/meal/UpdateMeal"
import LoginInNativeApp from "features/auth/Components/LoginInNativeApp"
import CreateAccount from "features/profile/CreateAcount"
import ScheduleDetails from "features/schedule/ScheduleDetails"
import BarcodeScanner from "features/meal/BarcodeScanner"
import MyList from "features/food/MyFoods/MyList"
import MyFoods from "features/food/MyFoods"
import MySchedule from "features/food/MyFoods/MySchedule"
import YourGoal from "features/nutritionTarget/YourGoal"
import UpdateBodyAndGoal from "features/nutritionTarget/UpdateBodyAndGoal"
import ManualEditGoal from "features/nutritionTarget/ManualEditGoal"
import SearchFoods from "features/food/SearchFoods"
import WelcomeOnboarding from "features/onboarding/WelcomeOnboarding"
import FavoriteMeals from "features/favoriteMeals/FavoriteMeals"
import FavoriteMealDetails from "features/favoriteMeals/FavoriteMealDetails"
import Water from "features/water/Water"

const RefreshablePage = ({ Page }: { Page: React.ComponentType }) => {
  const refreshCount = useAppSelector((state) => state.profile.refreshCount)
  return <Page key={refreshCount} />
}

export const routes: RouteObject[] = [
  {
    path: PATHS.app.root,
    element: <AppLayout />,
    children: [
      {
        index: true,
        element: <Home />,
      },

      {
        path: PATHS.app.favoriteMeal.details,
        element: <FavoriteMealDetails />,
      },
      {
        path: PATHS.app.myFoods.root,
        element: <MyFoods />,
        children: [
          {
            index: true,
            element: <FavoriteMeals />,
          },

          {
            path: PATHS.app.myFoods.recipes,
            element: <MyList />,
          },

          { path: PATHS.app.myFoods.schedules, element: <MySchedule /> },
        ],
      },

      {
        path: PATHS.app.food.search,
        element: <SearchFoods />,
      },

      {
        path: PATHS.app.meal.tutorial,
        element: <Tutorial />,
      },

      {
        path: PATHS.app.meal.scan,
        element: <ScanMeal />,
      },
      {
        path: PATHS.app.meal.edit,
        element: <UpdateMeals />,
      },
      {
        path: PATHS.app.food.create,
        element: <CreateFood />,
      },

      {
        path: PATHS.app.food.edit,
        element: <UpdateFood />,
      },
      {
        path: PATHS.app.food.details,
        element: <FoodDetails />,
      },

      { path: PATHS.app.yourGoal.root, element: <YourGoal /> },
      {
        path: PATHS.app.yourGoal.updateBodyAndGoal,
        element: <RefreshablePage Page={UpdateBodyAndGoal} />,
      },
      {
        path: PATHS.app.yourGoal.manualEditGoal,
        element: <ManualEditGoal />,
      },

      { path: PATHS.app.profile.createAccount, element: <CreateAccount /> },

      { path: PATHS.app.welcomeOnboarding, element: <WelcomeOnboarding /> },

      {
        path: PATHS.app.personalInfo,
        element: <RefreshablePage Page={PersonalInfo} />,
      },
      {
        path: PATHS.app.setGoal,
        element: <RefreshablePage Page={SetGoal} />,
      },

      { path: PATHS.app.overview, element: <Overview /> },

      {
        path: PATHS.app.schedule.details,
        element: <ScheduleDetails />,
      },

      { path: PATHS.app.barcodeScanner.root, element: <BarcodeScanner /> },

      { path: PATHS.app.water.root, element: <Water /> },
    ],
  },

  {
    path: PATHS.auth.loginInNativeApp,
    element: <LoginInNativeApp />,
  },

  {
    path: "*",
    element: <Navigate to={PATHS.app.root} />,
  },
]

export default routes
